import { QRCodeSVG } from "qrcode.react";

/** Isi QR: tautan auto-login hotspot bila alamat login diisi di Setting, jika tidak cukup kodenya. */
export const qrValue = (v, loginUrl = "") => {
  if (!loginUrl) return v.username;
  const sep = loginUrl.includes("?") ? "&" : "?";
  return `${loginUrl}${sep}username=${encodeURIComponent(v.username)}&password=${encodeURIComponent(v.password || v.username)}`;
};

export const VoucherQr = ({ v, loginUrl = "", size = 46 }) => (
  <QRCodeSVG value={qrValue(v, loginUrl)} size={size} level="M" bgColor="#ffffff" fgColor="#000000" />
);
